const actions = {
  CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION',
  createNotification: (payload) => ({
    type: actions.CREATE_NOTIFICATION,
    payload,
  }),
};
export default actions;
